import {
    PurchasingContainer,
    PurchasingRegister,
} from '@Purchasing/Data/DataSource/Container'
import { Purchase, PurchaseStatus } from '@Purchasing/Domain/Model/PurchaseProcess'
import { UpdatePurchasePayload } from '@Purchasing/Data/DataSource/API/Entity/PurchaseProcess'
import { useCallback, useState } from 'react'

export const usePurchaseActions = () => {
    const createUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseCreatePurchase
    )
    const updateUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseUpdatePurchase
    )
    const statusUseCase = PurchasingContainer.get(
        PurchasingRegister.UseCaseChangePurchaseStatus
    )

    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<string | null>(null)

    const runAction = useCallback(
        async <T>(action: () => Promise<T>, fallbackError: string) => {
            setLoading(true)
            setError(null)
            try {
                return await action()
            } catch (e: any) {
                console.error(e)
                setError(e?.response?.data?.message ?? fallbackError)
                return null
            } finally {
                setLoading(false)
            }
        },
        []
    )

    const generate = useCallback(
        (processId: string, notes?: string) =>
            runAction<Purchase>(
                () => createUseCase.execute(processId, { notes }),
                'Erro ao gerar a compra'
            ),
        [createUseCase, runAction]
    )

    const save = useCallback(
        (processId: string, payload: UpdatePurchasePayload) =>
            runAction<Purchase>(
                () => updateUseCase.execute(processId, payload),
                'Erro ao atualizar a compra'
            ),
        [updateUseCase, runAction]
    )

    const changeStatus = useCallback(
        (processId: string, status: PurchaseStatus) =>
            runAction<Purchase>(
                () => statusUseCase.execute(processId, status),
                'Erro ao alterar o status da compra'
            ),
        [statusUseCase, runAction]
    )

    return { generate, save, changeStatus, loading, error }
}
